import React from 'react'

// Enums
import Order from '../../enums/order.enum';

// Components
import IconTightArrow from '../Icons/IconTightArrow/IconTightArrow';
import { SortCycleTableProps } from '../CycleTable/types';

type TableThProps = {
  classNameTh?: string;
  classNameBlock?: string;
  option: { KEY: string, NAME: string };
  dataSort?: SortCycleTableProps;
  onClick?: (optionKey: string, dataSort: SortCycleTableProps) => void;
}

const TableTh: React.FC<TableThProps> = ({
  classNameTh,
  classNameBlock,
  option,
  dataSort,
  onClick,
}) => {
  const handleClick = () => {
    onClick(option.KEY, dataSort);
  }

  return (
    <th onClick={handleClick} className={`c-table-th cursor-pointer ${classNameTh}`}>
      <div className={`flex flex-row flex-nowrap ${classNameBlock} ${option.KEY === dataSort?.key ? 'text-primary' : ''}`}>
        <span className='pr-0.5'>{option.NAME}</span>
        <IconTightArrow iconClassName={`${option.KEY === dataSort?.key ? '' : 'invisible'} ${dataSort?.option === Order.ASC ? 'rotate-0' : 'rotate-180'}`} />
      </div>
    </th>
  )
};

export default TableTh;